import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/drawer-device');
};

const create = (data) => {
	return Client.post(`/admin/api/drawer-device`, data);
};

const find = (drawerNo) => {
	return Client.get(`/admin/api/drawer-device/${drawerNo}`);
};

const update = (OriginalDrawerNo, data) => {
	return Client.put(`/admin/api/drawer-device/${OriginalDrawerNo}`, data);
};

const updateConfig = (DefaultDrawerNo, OnlyOpenDrawerForCashPayment, Items) => {
	return Client.put(`/admin/api/drawer-device`, {
		DefaultDrawerNo,
		OnlyOpenDrawerForCashPayment,
		Items,
	});
};

const remove = (drawerNo) => {
	return Client.del(`/admin/api/drawer-device/${drawerNo}`);
};

const test = (data, machineID, opName) => {
	return Client.post(
		`/admin/api/drawer-device/test-open-drawer/${machineID}/${opName}`,
		data
	);
};

const listCashdrawerMode = () => {
	return Client.get(`/admin/api/drawer-device/drawer-manifest`);
};

export default {
	list,
	find,
	create,
	update,
	updateConfig,
	remove,
	test,
	listCashdrawerMode,
};
